module.exports = __webpack_public_path__ + "img/36.a9e28ea1.jpg";